import React from 'react'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'

import { selectors as UsersSelectors } from 'data/users'
import {
  StatisticsContainer,
  StatisticsCountItem,
  StatisticsInfoItem,
} from './Layout'
import {
  getWordsCount,
  getCharsCount,
  getEmojisCount,
  formatUsernames,
} from './utils'

const getCounters = (str = '') => ({
  wordsCount: getWordsCount(str),
  charsCount: getCharsCount(str),
  emojisCount: getEmojisCount(str),
})

const getEmojiMood = count => {
  if (count === 0) {
    return ' 😿 '
  }
  if (count < 5) {
    return ' 😺 '
  }
  if (count < 10) {
    return ' 😻 '
  }
  if (count < 20) {
    return ' 🙀 '
  }
  return ' 😹 '
}

const Statistics = ({ note, allUsers }) => {
  const { wordsCount, charsCount, emojisCount } = getCounters(
    note.get('contentAsText')
  )
  const writerUsernames = formatUsernames(allUsers, note.get('writerIds'))
  const commenterUsernames = formatUsernames(allUsers, note.get('commenterIds'))
  const mentionedUsernames = formatUsernames(allUsers, note.get('mentionedIds'))
  return [
    <StatisticsContainer key="counters">
      <StatisticsCountItem>
        <b>{wordsCount} </b>
        <FormattedMessage
          id="notes.wordsCount"
          defaultMessage={`{count, plural,
            one {word}
            other {words}
          }`}
          values={{ count: wordsCount }}
        />
      </StatisticsCountItem>
      <StatisticsCountItem>
        <b>{charsCount} </b>
        <FormattedMessage
          id="notes.charsCount"
          defaultMessage={`{count, plural,
            one {character}
            other {characters}
          }`}
          values={{ count: charsCount }}
        />
      </StatisticsCountItem>
      <StatisticsCountItem>
        <b>{emojisCount} </b>
        <FormattedMessage
          id="notes.emojisCount"
          defaultMessage={`{count, plural,
            one { emoji}
            other { emojis}
          }`}
          values={{ count: emojisCount }}
        />
        {` ${getEmojiMood(emojisCount)}`}
      </StatisticsCountItem>
    </StatisticsContainer>,
    <div key="separator" className="padding-bottom-medium" />,
    note.get('writerIds').size > 0 ? (
      <StatisticsInfoItem key="writers">
        {writerUsernames} wrote on this doc {'🙌 '}
      </StatisticsInfoItem>
    ) : (
      false
    ),
    note.get('commenterIds').size > 0 ? (
      <StatisticsInfoItem key="commenters">
        {commenterUsernames} commented on this doc {'💬 '}
      </StatisticsInfoItem>
    ) : (
      false
    ),
    note.get('mentionedIds').size > 0 ? (
      <StatisticsInfoItem key="mentioned">
        {mentionedUsernames} were mentioned {'🌀 '}
      </StatisticsInfoItem>
    ) : (
      false
    ),
  ]
}

const enhance = connect((state, { note }) => {
  const str = note.get('contentAsText')
  return {
    wordsCount: getWordsCount(str),
    charsCount: getCharsCount(str),
    emojisCount: getEmojisCount(str),
    allUsers: UsersSelectors.getAllUsers(state),
  }
})

export default enhance(Statistics)
